import { HttpRequest, HttpHandlerFn, HttpEvent, HttpEventType } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { LoggerService } from "../../shared/services/logger.service";
import { inject } from "@angular/core";

export function loggingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const logger = inject(LoggerService);

  return next(req).pipe(tap(event => {
    if (event.type === HttpEventType.Response) {
      const status = event.status;
      if (status >= 400 && status !== 401 && status !== 403) {
        logger.error(`[HTTP] ${req.method} ${req.url} - Status: ${status}`, event);
      }
    }
  }));
}